import { Field } from '@ark-ui/react'
import { ClipboardEventHandler } from 'react'
import { cn } from '../utlis/cn'

export type TextInputProps = {
    value?: string
    initialValue?: string
    label?: string
    placeholder?: string
    className?: string
    error?: string
    helperText?: string
    type?: 'password' | 'text' | 'email' | 'number'
    rightControl?: React.ReactNode
    onChange?: (value: string) => void
    disableAutocomplete?: boolean
    onPaste?: ClipboardEventHandler<HTMLInputElement>
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    icon?: React.ReactNode
    disabled?: boolean
}

export function TextInput(props: TextInputProps) {
    const border = 'border-muse-toplit rounded-[12px] focus:outline-1 focus:outline-white/40'
    const bg = 'bg-[rgba(255,255,255,0.03)]'
    const shadow = 'shadow-glow  placeholder-[rgba(255,255,255,0.3)]'
    const style = 'w-full px-[16px] py-[8px]'

    let errorStyles: string[] = []
    if (props.error) {
        errorStyles = [
            'shadow-[inset_0px_0px_16px_0px_rgba(252,80,80,0.35)]',
            'border border-[#FC505060] outline-1 outline-[#FC505060]',
            'text-[#FC5050]',
        ]
    }

    return (
        <Field.Root invalid={!!props.error}>
            <div className="flex flex-col gap-2">
                {props.label && <Field.Label className="t-base-medium leading-[20px]">{props.label}</Field.Label>}
                <div className="relative">
                    {props.icon && <div className="absolute left-3 top-1/2 -translate-y-1/2">{props.icon}</div>}
                    <Field.Input
                        defaultValue={props.initialValue}
                        type={props.type}
                        className={cn(
                            border,
                            bg,
                            shadow,
                            style,
                            errorStyles,
                            props.icon ? 'pl-[44px]' : '',
                            props.className
                        )}
                        value={props.value}
                        onChange={(e) => props.onChange?.(e.target.value)}
                        placeholder={props.placeholder}
                        autoComplete={props.disableAutocomplete ? 'off' : undefined}
                        disabled={props.disabled}
                        onPaste={props.onPaste}
                        onFocus={props.onFocus}
                        onBlur={props.onBlur}
                    />
                    <div className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center">
                        {props.rightControl}
                    </div>
                </div>
            </div>
            {props.helperText && <Field.HelperText>{props.helperText}</Field.HelperText>}
            {props.error && <Field.ErrorText className="text-muse-danger">{props.error}</Field.ErrorText>}
        </Field.Root>
    )
}
